angular.module('mtic.components.dashboards.student_general')
  .directive('studentModules', function (
    $http,
    $log,
    $timeout,
    TIMING_CONSTANTS,
    DEV_VARIABLES,
    EventManager,
    StudentDataService,
    PlatformService,
    MapStateService
  ) {
    return {
      templateUrl: 'template.html',
      scope: {
        selectedClass: '='
      },
      link: function (scope, element) {
        
        scope.moduleDataReady = false;
        MapStateService.isLeaderboardAvailable = false;
        scope.isLeaderboardAvailable = function(){
          return MapStateService.isLeaderboardAvailable;
        } 
        scope.isLeaderboardHidden = false;
        // console.log(StudentDataService.getUserSchools())
        if (StudentDataService.getUserSchools().$$state.value.length === 1){
          if(StudentDataService.getUserSchools().$$state.value[0].name.toLowerCase().includes('baqa')){
            scope.is_baqa = true
          }
        }

        var eventManager = new EventManager('studentModules', scope);
        var screen_width = 0;
        var is_mobile = navigator.userAgent.match(/Android/i) || (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
        if (is_mobile) {
          screen_width = window.screen.width
        } else {
          screen_width = window.innerWidth;
        }
        if(screen_width < 1200){
          var timer = is_mobile ? 500 : 0;
          $timeout(function(){
            eventManager.broadcast('student:toggle:Sidepanel', false);
          }, timer)
        }
        // eventManager.listen('') // isLeaderboardHidden

        
        scope.$on('$destroy', function() {
          MapStateService.setActiveModule("");
        });

        scope.activateLeaderboard = function(){
          //$log.log('activateLeaderboard', scope.selectedClass, scope.moduleMapData)

          eventManager.broadcast('student:leaderboard:open', {
            classId: scope.selectedClass.id, 
            classType: renderLeaderboardClassTypeFromModuleId(scope.selectedClass.module_id),
            classCountry: scope.selectedClass.country,
          });
        }

        eventManager.listen('activate:leaderboard', function(){
          if(scope.isLeaderboardAvailable() && !scope.isLeaderboardHidden){
            scope.activateLeaderboard();
          }
        })

        var checkForOpenLeaderboards = function(){
          if (scope.selectedClass){
            var isValid = true;
            // _.each(DEV_VARIABLES.GROUPS.LUXEMBOURG.TEACHERLESS_MODULES, function(classModule){
            //   if (classModule.group_id === scope.selectedClass.id){
            //     isValid = false;
            //   }
            // })
            if (!isValid){
              return false;
            }
            var districtId = 'luxembourg';
            var classType = renderLeaderboardClassTypeFromModuleId(scope.selectedClass.module_id);
            var path = 'https://us-central1-calculating-cats.cloudfunctions.net/hasLeaderboardsOpen';
            // $log.log('hasLeaderboardsOpen >> classType', classType)
            $http.post(path, {districtId: districtId, classType: classType}).then(function(res){
              //$log.log('hasLeaderboardsOpen', res)
              try {
                if (res.data.data.isValid){
                  $timeout(function(){
                    MapStateService.isLeaderboardAvailable = true;
                  })
                }
              }
              catch(e){}
            })
          }
        }

        var renderLeaderboardClassTypeFromModuleId = function(moduleId){
          var classType = 'no_class'; // default
          DEV_VARIABLES.GROUPS.LUXEMBOURG.AVAILABLE_MODULES.forEach(moduleCollection => {
            if(moduleCollection.module_id === moduleId){
              classType = moduleCollection.foreign_slug;
            }
          })
          return classType;
        }

        var init = function(firstInit, triggerRefresh) {
          scope.moduleDataReady = false;
          scope.moduleMapData = null;
          checkForOpenLeaderboards();
          StudentDataService.getModuleData(true)
          .then(function(moduleMapData){
            if(triggerRefresh) {
              $log.debug('[[studentModules]] RE-INITED (refresh)', moduleMapData)
              scope.moduleMapData = moduleMapData;
              $timeout(() => {
                eventManager.broadcast('app:module:refresh/ready', {})
              }, TIMING_CONSTANTS.STUDENT_DATA_REFRESH_DELAY_MS);
            }
            else if(firstInit) {
              $log.debug('[[studentModules]] RE-INITED (first)', moduleMapData)
              scope.moduleMapData = moduleMapData;
              eventManager.broadcast('app:secondary:opened',moduleMapData.resource_slug)
            }
            else{
              $log.debug('[[studentModules]] RE-INITED', moduleMapData)
              $timeout(function(){
                scope.moduleMapData = moduleMapData;
              }, TIMING_CONSTANTS.INSTANT);
            }
          })
        };

        // EVENT SETUP
        eventManager.listen('student:cycle:open', function (e) {
          $log.log('student:cycle:open');
          init(true);
        });

        eventManager.listen('module:change:submodule', function (e) {
          scope.isLeaderboardHidden = false; // bad idea... they cant bring it back
        });

        eventManager.listen('module:open:resource', function (e) {
          scope.isLeaderboardHidden = true; // bad idea... they cant bring it back
        });
        

        // 

        eventManager.listen('app:module:open', function (e) {
          $log.log('app:module:open');
          init(false);
        });

        eventManager.listen('module:reload:map', function (e, args) {
          init(false);
        });

        eventManager.listen('app:module:refresh', function (e) {
          init(false, true);
        });

        eventManager.listen('creating-items-done', function (e) {
          scope.moduleDataReady = true;
        });

        scope.$watch('selectedClass', function(selectedClass){
          if(selectedClass){
            // $log.log('selectedClass: ' , selectedClass)
            eventManager.broadcast('student:cycle:open', {});
            checkForOpenLeaderboards();
          }
        })

      }
    }
  });
